
import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';

const Navigation = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'About', path: '/' },
    { name: 'Services', path: '/services' },
    { name: 'Portfolio', path: '/' },
    { name: 'Shop', path: '/' },
    { name: 'PM Launchpad', path: '/' },
    { name: 'Contact', path: '/contact' },
  ];

  return (
    <motion.nav
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.6, ease: 'easeOut' }}
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-warm-white shadow-sm' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center group cursor-pointer">
            <h1 className="font-playfair text-2xl font-semibold text-charcoal tracking-tight group-hover:text-warm-gold transition-colors duration-300">
              KL Consulting Group
            </h1>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center space-x-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`font-inter text-sm font-medium transition-colors duration-300 cursor-pointer whitespace-nowrap ${
                  location.pathname === link.path
                    ? 'text-warm-gold'
                    : 'text-charcoal hover:text-warm-gold'
                }`}
              >
                {link.name}
              </Link>
            ))}
            <Link
              to="/book-consultation"
              className="font-inter text-sm font-semibold bg-warm-gold text-charcoal px-6 py-3 rounded-full hover:bg-soft-bronze transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              Book a Consultation
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button className="lg:hidden text-charcoal w-10 h-10 flex items-center justify-center cursor-pointer">
            <i className="ri-menu-line text-2xl"></i>
          </button>
        </div>
      </div>
    </motion.nav>
  );
};

export default Navigation;
